interface SamphireLogoProps {
  width?: number;
  className?: string;
}

export function SamphireLogo({
  width = 355,
  className = "",
}: SamphireLogoProps) {
  // Original dimensions from the SVG
  const originalWidth = 355;
  const originalHeight = 84;

  // Calculate height to maintain aspect ratio
  const height = (width / originalWidth) * originalHeight;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${originalWidth} ${originalHeight}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M10.4458 44.5627C10.5336 53.604 16.5026 57.3785 25.7194 57.3785C34.234 57.3785 39.6763 54.0429 39.6763 48.0739C39.6763 42.8071 35.8141 39.9982 29.1428 38.3304L16.5903 34.907C7.02237 32.4491 1.14114 27.4457 1.14114 18.58C1.14114 7.95866 9.74353 0.760742 24.4027 0.760742C38.2719 0.760742 47.8398 6.11529 48.3665 19.9845H38.0963C38.0963 12.7865 33.5318 9.01202 23.876 9.01202C16.0637 9.01202 11.3236 12.6988 11.3236 17.6144C11.3236 22.8812 15.9759 25.1634 23.5249 27.0068L32.8295 29.4646C43.7142 32.2736 49.8588 37.3648 49.8588 47.1961C49.8588 59.3975 39.5886 65.7176 25.5439 65.7176C11.4991 65.7176 0 59.2219 0 44.5627H10.4458Z"
        fill="currentColor"
      />
      <path
        d="M53.8381 53.5161C53.8381 45.7915 59.2805 40.9636 67.6195 39.208L83.332 35.7846V34.2924C83.332 29.3767 79.7331 26.0411 73.1496 26.0411C68.0584 26.0411 63.845 28.3234 63.5816 34.9946H54.277C54.5404 25.3389 61.7383 19.3699 73.0618 19.3699C86.141 19.3699 92.9878 26.0411 92.9878 35.6091V53.6039C92.9878 58.6073 93.2511 61.9429 93.9534 64.0496V64.4885H84.4732C84.2098 63.2596 84.0343 61.5918 83.9465 60.714C83.8587 59.5729 83.332 58.9584 82.542 58.9584C81.4887 58.9584 80.7864 59.7484 79.9086 60.6262C77.5386 63.1719 73.7641 65.5419 68.234 65.5419C60.1583 65.5419 53.8381 61.504 53.8381 53.5161ZM83.4198 43.2459V41.6659L71.394 45.0015C66.215 46.3182 63.7572 49.0394 63.7572 52.9894C63.7572 56.9395 66.9173 59.3096 70.604 59.3096C77.8019 59.3096 83.4198 52.2872 83.4198 43.2459Z"
        fill="currentColor"
      />
      <path
        d="M101.488 20.599H111.056V23.2324C111.056 25.0758 111.846 25.778 113.075 25.778C114.04 25.778 114.655 25.1636 115.445 24.4613C117.288 22.4424 120.887 19.4579 126.944 19.4579C130.894 19.4579 134.493 20.8624 137.214 23.408C138.794 24.7247 139.935 25.0758 141.164 25.0758C143.446 25.0758 144.939 23.9346 146.606 22.7057C149.854 20.5112 152.663 19.4579 156.087 19.4579C165.479 19.4579 171.272 24.7247 171.272 35.5215V64.4888H161.704V37.6282C161.704 30.6059 158.193 27.5336 153.102 27.5336C145.641 27.5336 141.34 34.0293 141.164 43.685V64.4888H131.596V37.6282C131.596 30.6059 128.173 27.5336 123.52 27.5336C117.025 27.5336 111.143 33.5904 111.056 43.685V64.4888H101.488V20.599Z"
        fill="currentColor"
      />
      <path
        d="M219.537 42.3683C219.537 57.0274 211.11 65.6298 200.752 65.6298C196.363 65.6298 193.642 64.1376 191.359 62.4698C189.604 61.1531 187.673 61.5042 187.673 64.1376V83.0979H178.105V20.5989H187.321V22.7056C187.321 23.9346 188.55 24.3735 189.867 23.2323C192.852 20.6867 196.714 19.1067 200.927 19.1067C211.11 19.1067 219.537 27.2702 219.537 42.3683ZM187.321 42.2805C187.321 52.5507 191.447 58.2563 198.645 58.2563C204.526 58.2563 209.793 53.0774 209.793 42.2805C209.793 31.4836 204.965 26.4802 198.645 26.4802C191.447 26.4802 187.321 31.9225 187.321 42.2805Z"
        fill="currentColor"
      />
      <path
        d="M233.64 1.98975V64.4888H224.072V1.98975H233.64ZM246.104 27.5336C239.609 27.5336 233.728 33.5904 233.64 43.685L232.411 24.5491L233.64 20.599V23.2324C233.64 25.0758 234.518 25.778 235.659 25.778C236.624 25.778 237.239 25.1635 238.029 24.4613C239.872 22.4424 243.471 19.4579 249.616 19.4579C257.34 19.4579 263.748 24.2857 263.748 34.0293V64.4888H254.18V37.6282C254.18 30.6059 250.757 27.5336 246.104 27.5336Z"
        fill="currentColor"
      />
      <path
        d="M287.375 20.5989H296.943V22.7933C296.943 24.6367 299.138 24.8123 300.191 23.5834C301.069 22.6178 303.176 20.3355 306.775 19.6333C308.267 19.2822 309.759 19.2822 311.427 19.4577V27.9723C310.286 27.7968 309.233 27.7968 308.004 27.8846C301.069 28.8501 296.943 35.3458 296.943 43.5093V64.4886H287.375V20.5989Z"
        fill="currentColor"
      />
      <path
        d="M312.832 42.1925C312.832 28.7623 321.171 19.3699 334.337 19.3699C346.012 19.3699 354 27.4456 354.527 40.3492C354.615 41.7536 354.527 42.3681 354.439 43.7726H322.926C323.014 51.6727 327.14 58.2562 334.689 58.2562C339.078 58.2562 343.028 55.7984 343.993 50.1805H354.088C352.332 60.4507 344.871 65.7174 335.04 65.7174C321.171 65.7174 312.832 56.0617 312.832 42.1925ZM334.323 26.9189C330.987 26.9189 328.266 28.1478 326.335 30.3423C324.228 32.449 323.087 37.9791 329.407 37.9791H344.242C343.891 30.2545 339.239 26.9189 334.323 26.9189Z"
        fill="currentColor"
      />
      <path
        d="M280.338 20.5988V64.4885H270.683V20.5988H280.338Z"
        fill="currentColor"
      />
      <path
        d="M269.629 5.96901C269.629 2.80894 272.438 0 275.598 0C278.758 0 281.48 2.80894 281.48 5.96901C281.48 9.12907 278.758 11.938 275.598 11.938C272.438 11.938 269.629 9.12907 269.629 5.96901Z"
        fill="currentColor"
      />
    </svg>
  );
}
